import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const posHeaderOrderFormSlice = createSlice({
  name: "posHeaderOrderForm",
  initialState: {
    customer: null,
    contact: 0,
    BatchNo: 0,
    invo: 0,
    date: dayjs(),
    dealer: null,
    outlet: null,
    deliveryDate: dayjs(),
    balance: 0,
    edit: false,
    salesBill: 0,
    user: null,
    creditLimit: 0,
    other: { Name: "" },
    otherMenuItems: [],
    orderNo: "",
    oldBillData: [],
    kotDifferenciatedTableData: [],
    holdedBillStatus: 0,
    partyWiseRate: false,
    priceLevel: { label: "A" },
    address: "",
    vatNo: "",
    isCostShow: false,
    narration: "",
    sino: 0,
    cashRecievedOnEditMode: 0,
    partyCrDr: "Dr",
    prevBill_partyCrDr: "",
    billTime: new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }),
  },
  reducers: {
    updateSelected: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetState: () => {
      // Reset the state to its initial/default values
      return {
        customer: null,
        contact: 0,
        BatchNo: 0,
        edit: false,
        // invo: 0,
        date: dayjs(),
        deliveryDate: dayjs(),
        // dealer: null,
        // outlet: null,
        balance: 0,
      };
    },
  },
});

export const { updateSelected, resetState } = posHeaderOrderFormSlice.actions;
export default posHeaderOrderFormSlice.reducer;
